import { Loading, styled } from '@teko/ds-mobile';
import { NoProductsFound } from '@teko/teko-ecommerce';
import React from 'react';
import { t } from '../../i18n.es.js';
import { AddressForm } from './AddressForm.es.js';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const AddressFormWithData = (props) => {
  const _a = props, {
    editingAddress: addressId,
    userService,
    address,
    loading
  } = _a, rest = __objRest(_a, [
    "editingAddress",
    "userService",
    "address",
    "loading"
  ]);
  return /* @__PURE__ */ React.createElement(Loading, {
    isLoading: loading
  }, !address && addressId && !loading ? /* @__PURE__ */ React.createElement(NotFoundWrapper, null, /* @__PURE__ */ React.createElement(NoProductsFound, {
    text: t("Kh\xF4ng t\xECm th\u1EA5y \u0111\u1ECBa ch\u1EC9 c\u1EE7a b\u1EA1n"),
    show: true
  })) : !loading ? /* @__PURE__ */ React.createElement(AddressForm, __spreadValues({
    userService,
    editingAddress: address
  }, rest)) : null);
};
const NotFoundWrapper = styled.div`
  height: calc(100vh - 3.5rem);
  display: flex;
  justify-content: center;
  align-items: center;
`;

export { AddressFormWithData };
